/**
 * Configuration for resizable columns.
 *
 * To add a new resizable column:
 * 1. Add entry to RESIZABLE_COLUMNS array
 * 2. Add corresponding CSS width variables to columns.module.scss
 * 3. That's it! The system handles the rest automatically.
 */

type ResizableColumn = {
  key: string;
  defaultWidth: number;
  /** Only rendered when canAgentEntry is true */
  agentEntryOnly?: boolean;
};

/**
 * List of resizable columns.
 */
export const RESIZABLE_COLUMNS: ResizableColumn[] = [
  { key: 'office_member', defaultWidth: 98, agentEntryOnly: true },
  { key: 'title', defaultWidth: 220 },
  { key: 'ap_payee_name', defaultWidth: 128 },
  { key: 'total_amount', defaultWidth: 98 },
  { key: 'report_approval_names', defaultWidth: 128 },
];

/**
 * Check if a column is resizable
 */
export const isResizable = (columnKey: string): boolean => {
  return RESIZABLE_COLUMNS.some((col) => col.key === columnKey);
};
